export const clearLocalStorage = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('email');
  localStorage.removeItem('name');
  localStorage.removeItem('accountType');
  localStorage.removeItem('companyId');
};
